import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'manageLaboratory',
  initialState: {
    laboratoryCategoryList: [],
    laboratoryCategoryListDetails: [],
    laboratoryCategoryListLoading: false,
    laboratoryCategoryListPaginationData: {},
    laboratorySubCategoryList: [],
    laboratorySubCategoryListDetails: [],
    laboratorySubCategoryListLoading: false,
    laboratorySubCategoryListPaginationData: {},
    labTestList: [],
    labTestListLoading: false,
    labTestListPaginationData: {},
    laboratoryCategoryListDetailsLoading: false,
    laboratorySubCategoryListDetailsLoading: false,
    updateLabCategory: false,
    cc: false,
    updateLabSubCategory: false,
    updateLabTestList: false,

    addLabTestApiSuccess: false,
    deleteLabTestApiSuccess: false,
    editLabTestApiSuccess: false,
    labTestApiError: null,

    addLabTestCategoryApiSuccess: false,
    deleteLabTestCategoryApiSuccess: false,
    editLabTestCategoryApiSuccess: false,
    labTestCategoryApiError: null,
  },
  reducers: {
    // get category
    getListLaboratoryCategory: (state, { payload }) => {
      state.laboratoryCategoryListLoading = true
    },
    getListLaboratoryCategoryDataApiSuccess: (state, { payload }) => {
      state.laboratoryCategoryListLoading = false
      state.laboratoryCategoryList = payload?.payload?.data
      state.laboratoryCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getListLaboratoryCategoryDataApiFailed: (state, { payload }) => {
      state.laboratoryCategoryListLoading = false
    },

    // Sub type Category
    getListLaboratorySubCategory: (state, { payload }) => {
      state.laboratorySubCategoryListLoading = true
    },
    getListLaboratorySubCategoryDataApiSuccess: (state, { payload }) => {
      state.laboratorySubCategoryListLoading = false
      state.laboratorySubCategoryList = payload?.payload?.data
      state.laboratorySubCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getListLaboratorySubCategoryDataApiFailed: (state, { payload }) => {
      state.laboratoryCategoryListLoading = false
    },
    // get Lab test
    getLabTestList: (state, { payload }) => {
      state.labTestListLoading = true
    },
    getLabTestListApiSuccess: (state, { payload }) => {
      state.labTestListLoading = false
      state.labTestList = payload?.payload?.data
      state.labTestListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getLabTestListApiFailed: (state, { payload }) => {},

    // lab category details
    getLaboratoryCategoryDetails: (state, { payload }) => {
      state.laboratoryCategoryListDetailsLoading = true
    },
    getLaboratoryCategoryDetailsApiSuccess: (state, { payload }) => {
      state.laboratoryCategoryListDetailsLoading = false
      state.laboratoryCategoryListDetails = payload.payload?.data
    },
    getLaboratoryCategoryDetailsApiFailed: (state, { payload }) => {
      //state.laboratoryCategoryListDetailsLoading = true
    },
    // Sub categories Details
    getLaboratorySubCategoryDetails: (state, { payload }) => {
      state.laboratorySubCategoryListDetailsLoading = true
    },
    getLaboratorySubCategoryDetailsApiSuccess: (state, { payload }) => {
      state.laboratorySubCategoryListDetailsLoading = false
      state.laboratorySubCategoryListDetails = payload?.payload?.data
    },
    getLaboratorySubCategoryDetailsApiFailed: (state, { payload }) => {
      //state.laboratorySubCategoryListDetailsLoading = true
    },
    // Add Lab Category
    addLaboratoryCategory: (state, { payload }) => {
      state.laboratoryCategoryListLoading = true
      state.updateLabCategory = false
    },
    addLaboratoryCategoryDataApiSuccess: (state, { payload }) => {
      state.updateLabCategory = true
      state.laboratoryCategoryListLoading = false
      state.addLabTestCategoryApiSuccess = true
      state.labTestCategoryApiError = payload?.payload
    },
    addLaboratoryCategoryDataApiFailed: (state, { payload }) => {
      state.laboratoryCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add lab Test
    addLabTestData: (state, { payload }) => {
      state.updateLabTestList = false
      state.labTestListLoading = true
    },
    addLabTestDataApiSuccess: (state, { payload }) => {
      state.updateLabTestList = true
      state.labTestListLoading = false
      state.addLabTestApiSuccess = true
      state.labTestApiError = payload?.payload
    },
    addLabTestDataApiFailed: (state, { payload }) => {
      state.labTestListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },
    // Add Sub Category
    addSubLaboratoryCategoryData: (state, { payload }) => {
      state.updateLabTestList = false
    },
    addSubLaboratoryCategoryDataApiSuccess: (state, { payload }) => {
      state.updateLabTestList = true
    },
    addSubLaboratoryCategoryDataApiFailed: (state, { payload }) => {
      state.updateLabTestList = false
    },
    // Update sab Laboratory Data
    updateSubLaboratoryCategoryData: (state, { payload }) => {
      state.laboratorySubCategoryList = state.laboratorySubCategoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateSubLaboratoryCategoryDataApiSuccess: (state, { payload }) => {},
    updateSubLaboratoryCategoryDataApiFailed: (state, { payload }) => {},
    // Update Category Data
    updateLaboratoryCategoryData: (state, { payload }) => {
      state.updateLabCategory = false
      state.laboratoryCategoryListLoading = true
      state.laboratoryCategoryList = state.laboratoryCategoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updateLaboratoryCategoryDataApiSuccess: (state, { payload }) => {
      state.updateLabCategory = true
      state.laboratoryCategoryListLoading = false
      state.editLabTestCategoryApiSuccess = true
      state.labTestCategoryApiError = payload?.payload
    },
    updateLaboratoryCategoryDataApiFailed: (state, { payload }) => {
      state.laboratoryCategoryListLoading = false
      alert(payload)
    },
    // delete category data
    deleteLaboratoryCategoryData: (state, { payload }) => {
      state.updateLabCategory = false
      state.laboratoryCategoryListLoading = true
      let updatedCategoryList = state.laboratoryCategoryList?.filter(
        (item) => item.id !== payload?.id,
      )
      state.laboratoryCategoryList = updatedCategoryList
    },
    deleteLaboratoryCategoryDataApiSuccess: (state, { payload }) => {
      state.updateLabCategory = true
      state.laboratoryCategoryListLoading = false
      state.deleteLabTestCategoryApiSuccess = true
      state.labTestCategoryApiError = payload?.payload
    },
    deleteLaboratoryCategoryDataApiFailed: (state, { payload }) => {
      state.laboratoryCategoryListLoading = false
      alert(payload)
    },
    // delete Sub Category Data
    deleteLaboratorySubCategory: (state, { payload }) => {
      let updatedSubCategoryList = state.laboratorySubCategoryList?.filter(
        (item) => item.id !== payload?.id,
      )
      state.laboratorySubCategoryList = updatedSubCategoryList
    },

    // update Lab Test
    updateLabTestApiData: (state, { payload }) => {
      state.updateLabTestList = false
      state.labTestListLoading = true
    },
    updateLabTestApiSuccess: (state, { payload }) => {
      state.updateLabTestList = true
      state.labTestListLoading = false
      state.editLabTestApiSuccess = true
      state.labTestApiError = payload?.payload
    },
    updateLabTestApiFailed: (state, { payload }) => {
      state.labTestListLoading = false
      state.updateLabTestList = false
      alert(payload)
    },

    // delete Lab Test
    deleteLabTestApiData: (state, { payload }) => {
      state.updateLabTestList = false
      state.labTestListLoading = true
    },
    deleteLabTestApiSuccess: (state, { payload }) => {
      state.updateLabTestList = true
      state.labTestListLoading = false
      state.deleteLabTestApiSuccess = true
      state.labTestApiError = payload?.payload
    },
    deleteLabTestApiFailed: (state, { payload }) => {
      alert(payload)
      state.labTestListLoading = false
    },

    deleteLaboratorySubCategoryApiFailed: (state, { payload }) => {},
    deleteLaboratorySubCategoryApiSuccess: (state, { payload }) => {},
    resetLabTestError: (state) => {
      state.addLabTestApiSuccess = false
      state.deleteLabTestApiSuccess = false
      state.editLabTestApiSuccess = false
      state.labTestApiError = null
      state.updateLabTestList = false
    },
    resetLabTestCategoryError: (state) => {
      state.addLabTestCategoryApiSuccess = false
      state.deleteLabTestCategoryApiSuccess = false
      state.editLabTestCategoryApiSuccess = false
      state.labTestCategoryApiError = null
      state.updateLabCategory = false
    },
  },
})

export const {
  // get category
  getListLaboratoryCategory,
  getListLaboratoryCategoryDataApiSuccess,
  getListLaboratoryCategoryDataApiFailed,

  // Sub type Category
  getListLaboratorySubCategory,
  getListLaboratorySubCategoryDataApiSuccess,
  getListLaboratorySubCategoryDataApiFailed,
  // get Lab test
  getLabTestList,
  getLabTestListApiSuccess,
  getLabTestListApiFailed,

  // lab category details
  getLaboratoryCategoryDetails,
  getLaboratoryCategoryDetailsApiSuccess,
  getLaboratoryCategoryDetailsApiFailed,
  // Sub categories Details
  getLaboratorySubCategoryDetails,
  getLaboratorySubCategoryDetailsApiSuccess,
  getLaboratorySubCategoryDetailsApiFailed,
  // Add Lab Category
  addLaboratoryCategory,
  addLaboratoryCategoryDataApiSuccess,
  addLaboratoryCategoryDataApiFailed,
  // Add lab Test
  addLabTestData,
  addLabTestDataApiSuccess,
  addLabTestDataApiFailed,
  // Add Sub Category
  addSubLaboratoryCategoryData,
  addSubLaboratoryCategoryDataApiSuccess,
  addSubLaboratoryCategoryDataApiFailed,
  // Update sab Laboratory Data
  updateSubLaboratoryCategoryData,
  updateSubLaboratoryCategoryDataApiSuccess,
  updateSubLaboratoryCategoryDataApiFailed,
  // Update Category Data
  updateLaboratoryCategoryData,
  updateLaboratoryCategoryDataApiSuccess,
  updateLaboratoryCategoryDataApiFailed,
  // delete category data
  deleteLaboratoryCategoryData,
  deleteLaboratoryCategoryDataApiSuccess,
  deleteLaboratoryCategoryDataApiFailed,
  // delete Sub Category Data
  deleteLaboratorySubCategory,
  deleteLaboratorySubCategoryApiFailed,
  deleteLaboratorySubCategoryApiSuccess,

  // update Lab Test
  updateLabTestApiData,
  updateLabTestApiSuccess,
  updateLabTestApiFailed,

  // delete Lab Test
  deleteLabTestApiData,
  deleteLabTestApiSuccess,
  deleteLabTestApiFailed,

  // reset
  resetLabTestError,
  resetLabTestCategoryError,
} = slice.actions

export default slice.reducer
